<template>
    <div class="regist">
        <nav-top :isLogin="1" title="相君科技平台注册"></nav-top>
        <div :style="isNext == 0 ? 'height:1000px' : 'height:700px'" class="regist_all">
            <div class="bigTitle">
                <div class="butOne">
                    <div class="ont-img">
                        <span>1</span>
                    </div>
                    <div class="text">基本信息</div>
                </div>
                <div class="butTwo">
                    <div :class="isNext === 1 ? 'lineActive' : ''" class="line"></div>
                </div>
                <div class="butThree">
                    <div :class="isNext === 1 ? 'butImgActive' : ''" class="ont-img">
                        <span>2</span>
                    </div>
                    <div class="text">输入密码</div>
                </div>
            </div>

            <div v-if="isNext === 0" class="regist_next">
                <div class="next_title">基本信息</div>
                <el-form ref="loginMessage" :model="param" :rules="rules">
                    <el-form-item prop="name">
                        <div class="next_input">
                            <el-input v-model="param.name" placeholder="*请输入姓名"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="email">
                        <div class="next_input">
                            <el-input v-model="param.email" placeholder="*请输入邮箱"></el-input>
                        </div>
                    </el-form-item>

                    <div class="next_input" id="noChecxk">
                        <el-input v-model="param.unitName" placeholder="请输入单位名称"></el-input>
                    </div>
                    <el-form-item prop="phone">
                        <div class="next_input">
                            <el-input v-model="param.phone" placeholder="*请输入手机号"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="code">
                        <div class="next_input">
                            <el-input v-model="param.code" placeholder="*请输入验证码"></el-input>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="next_look">
                    <div class="left">
                        <el-checkbox v-model="checked" @change="change"></el-checkbox>
                        我已阅读《<span @click="handlRegist">注册协议</span>》
                    </div>
                    <div class="right">
                        <button :disabled="code.status" class="btn" @click="handlCheckGetCode">{{ code.text }}</button>
                    </div>
                </div>
                <div class="next_btn" @click="handlCheckNext">
                    下一步
                </div>
            </div>
            <div v-else class="regist_pass">
                <div class="pass_title">输入密码</div>
                <div class="pass_input">
                    <!-- <el-input v-model="aginPass.onePassWord" placeholder="请输入密码"></el-input> -->


                    <el-form ref="login" :model="aginPass" :rules="rules">
                        <el-form-item prop="onePassWord">
                            <el-input v-model="aginPass.onePassWord" clearable placeholder="请输入新密码"
                                      prefix-icon="el-icon-lock"
                                      show-password>
                            </el-input>
                        </el-form-item>
                    </el-form>


                </div>
                <div class="pass_input">
                    <el-input v-model="aginPass.twoPassWord" placeholder="再次输入密码确认" show-password></el-input>
                </div>
                <div style="width: 65%; display: flex;align-items: center;justify-content: space-between">
                    <div class="pass_btn" style="background-image: none;background-color: #3d546f;width: 46%"
                         @click="goBack()">返回
                    </div>
                    <div class="pass_btn" @click="handlCheckYes" style="width: 46%">确认</div>
                </div>

            </div>
        </div>
        <nav-bom></nav-bom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                checked: false,
                param: {
                    name: '',
                    email: '',
                    unitName: '',
                    phone: '',
                    code: '',
                },
                aginPass: {
                    onePassWord: '',
                    twoPassWord: ''
                },
                isNext: 0,
                code: {
                    text: '获取验证码',
                    status: false,
                    value: ''
                },
                rules: {
                    onePassWord: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度应大于等于6个字符小于16个字符!',
                            trigger: "blur"
                        },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
                                console.log(passwordreg.test(value))
                                if (!passwordreg.test(value)) {
                                    callback(new Error('密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'))
                                } else {
                                    callback()
                                }
                            }
                        },
                    ],
                    name: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    },
                        {
                            min: 2,
                            max: 5,
                            message: '长度在 2 到 5 个字符',
                            trigger: 'blur'
                        }
                    ],
                    email: [{
                        required: true,
                        message: '请输入邮箱',
                        trigger: 'blur'
                    },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/
                                if (!passwordreg.test(value)) {
                                    callback(new Error('请输入正确的邮箱哦!'))
                                } else {
                                    callback()
                                }
                            }
                        },
                    ],
                    phone: [{
                        required: true,
                        message: '请输入手机号码',
                        trigger: 'blur'
                    },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /^(?:1\d{2})-?\d{5}(\d{3}|\*{3})$/
                                if (!passwordreg.test(value)) {
                                    callback(new Error('请输入正确的手机号哦!'))
                                } else {
                                    callback()
                                }
                            }
                        }],
                    code: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            handlRegist() {
                this.$router.push({
                    name: 'registAgreement',
                    params: {
                        type: 2,
                        title: '相君科技平台注册'
                    }
                })
            },
            change(e) {
                this.checked = e;
            },
            handlCheckNext() {
                if (!this.checked) {
                    this.$message.error('请阅读注册协议')
                    return
                }
                if (this.istrue()) {
                    this.$refs.loginMessage.validate(valid => {
                        if (valid) {
                            let _this = this; //
                            let param = new FormData();
                            param.append('phoneOrEmail', _this.param.phone);
                            param.append('type', '0');
                            param.append('verifyCode', _this.param.code);
                            _this.api.VerifyCode(param).then(res => {
                                console.log(res)
                                if (res.code == 1) {
                                    this.$message.error('验证码错误!')
                                } else {
                                    this.isNext = 1;
                                }

                            })
                        }
                    })
                } else {
                    this.$message.error('请注意填写内容/请阅读注册协议')
                }
            },
            //返回
            goBack() {
                this.isNext = 0;
                //清空密码
                this.aginPass.onePassWord = '';
                this.aginPass.twoPassWord = '';

            },
            handlCheckYes() {
                if (this.aginPass.onePassWord == this.aginPass.twoPassWord && this.aginPass.twoPassWord !== '') {
                    let _this = this;
                    _this.$refs.login.validate(valid => {
                        if (valid) {
                            var ap = {
                                companyName: _this.param.unitName,
                                email: _this.param.email,
                                name: _this.param.name,
                                password: _this.aginPass.twoPassWord,
                                phone: _this.param.phone,
                                serialVersionUID: 0
                            };
                            _this.api.register(ap).then(res => {
                                console.log(res)
                                if (res.code == 0) {
                                    _this.$message.success('注册成功');
                                    localStorage.setItem('lc_name', _this.param.name);
                                    _this.$router.push({
                                        path: '/login'
                                    })
                                } else {
                                    _this.$message.error(res.msg)
                                }
                            })
                        }
                    })

                } else {
                    this.$message.error("请保证两次输入密码一致");
                }
            },
            handlCheckGetCode() {
                this.code.status = true;
                let countdown = 60;
                if (this.xm.isPhone(this.param.phone)) {
                    let _this = this;
                    let param = new URLSearchParams();
                    param.append('phone', this.param.phone);
                    param.append('type', '0');
                    _this.api.sendCodeToPhone(param).then(res => {
                        console.log(res)
                        if (res.code == 0) {
                            _this.$message.success('发送成功');
                            _this.code.text = countdown + '秒';
                            _this.code.status = true;
                            let timer = setInterval(() => {
                                if (countdown > 0) {
                                    _this.code.text = countdown - 1 + '秒';
                                    countdown--;
                                } else {
                                    clearInterval(timer);
                                    _this.code.text = '获取验证码';
                                    _this.code.status = false;
                                }
                            }, 1000);
                        } else {
                            _this.code.status = false;
                            _this.$message.error(res.msg)
                        }
                    })
                } else {
                    this.code.status = false;
                    this.$message.error('手机号格式错误')
                }

            },
            istrue() {
                if (this.xm.isPhone(this.param.phone) || this.xm.isEmail(this.param.email) && this.param.unitName && this.param
                        .name &&
                    this.param.code && this.checked) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import '../../../../static/less/xm.less';

    /deep/ .el-input input::-webkit-input-placeholder {
        color: #f12b2b91;
    }

    /deep/ .el-input input::-moz-input-placeholder {
        color: #f12b2b91;
    }

    /deep/ .el-input input::-ms-input-placeholder {
        color: #f12b2b91;
    }

    #noChecxk /deep/ .el-input input::-webkit-input-placeholder {
        color: #c0c4cc;
    }

    #noChecxk /deep/ .el-input input::-moz-input-placeholder {
        color: #c0c4cc;
    }

    #noChecxk /deep/ .el-input input::-ms-input-placeholder {
        color: #c0c4cc;
    }


    /deep/ .el-input__inner {
        height: 60px;
        line-height: 60px;
    }

    /deep/ .el-checkbox__inner {
        margin-right: 10px;
    }

    .regist {
        width: @a;
        height: @a;

        .regist_all {
            width: @a;
            @column();

            .bigTitle {
                width: 800px;
                height: 140px;
                display: @flex;

                .butOne {
                    width: 100px;
                    height: 120px;
                    @column();

                    .ont-img {
                        width: 80px;
                        height: 80px;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        border-radius: 50%;
                        overflow: hidden;
                        @row();

                        span {
                            font-family: MicrosoftYaHei-Bold;
                            font-size: 48px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 2px;
                            color: #ffffff;
                        }
                    }

                    .text {
                        width: 100px;
                        height: 24px;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                        margin-top: 11px;
                    }
                }

                .butTwo {
                    width: 560px;
                    height: @a;
                    margin: 0 20px;
                    position: relative;

                    .line {
                        width: 560px;
                        height: 1px;
                        background-color: #aaaaaa;
                        position: absolute;
                        left: 0;
                        top: 48px;
                    }

                    .lineActive {
                        background-color: #1e6eee;
                    }
                }

                .butThree {
                    width: 100px;
                    height: 120px;
                    @column();

                    .ont-img {
                        width: 80px;
                        height: 80px;
                        background-color: #fff;
                        border-radius: 50%;
                        overflow: hidden;
                        border: solid 1px #aaaaaa;
                        @row();

                        span {
                            font-family: MicrosoftYaHei-Bold;
                            font-size: 48px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 2px;
                            color: #aaaaaa;
                        }
                    }

                    .butImgActive {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal;

                        span {
                            color: #fff;
                        }
                    }

                    .text {
                        width: 100px;
                        height: 24px;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;
                        margin-top: 11px;
                    }
                }
            }

            .regist_next {
                width: 800px;
                height: 780px;
                border-radius: 30px;
                border: solid 1px #aaaaaa;
                margin-top: 40px;
                @column();

                .next_title {
                    width: 180px;
                    height: 36px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #333333;
                }

                .next_input {
                    width: 520px;
                    height: 60px;
                    margin-top: 30px;
                }

                .next_look {
                    width: 520px;
                    height: 100px;
                    @row();

                    .left {
                        width: 60%;
                        height: @a;
                        display: flex;
                        align-items: center;

                        font-family: MicrosoftYaHei;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;

                        span {
                            font-family: MicrosoftYaHei;
                            font-size: 18px;
                            font-weight: normal;
                            letter-spacing: 1px;
                            color: #1e6fee;
                            cursor: pointer;
                        }
                    }

                    .right {
                        width: 40%;
                        height: @a;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;

                        .btn {
                            width: 130px;
                            height: 40px;
                            background-color: #fff;
                            border: solid 1px #aaaaaa;
                            font-family: MicrosoftYaHei;
                            font-size: 18px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 1px;
                            color: #333333;
                            @row();
                            cursor: pointer;
                        }
                    }
                }

                .next_btn {
                    width: 520px;
                    height: 80px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                    line-height: 80px;
                    text-align: center;
                    cursor: pointer;
                }
            }

            .regist_pass {
                width: 800px;
                height: 440px;
                border-radius: 30px;
                border: solid 1px #aaaaaa;
                margin-top: 40px;
                @column();

                .pass_title {
                    width: 160px;
                    height: 36px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #333333;
                    margin-bottom: 15px;
                }

                .pass_input {
                    width: 520px;
                    height: 60px;
                    margin-top: 30px;
                }

                .pass_btn {
                    width: 260px;
                    height: 80px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                    line-height: 80px;
                    text-align: center;
                    margin-top: 30px;
                    cursor: pointer;
                }
            }
        }


    }
</style>



// WEBPACK FOOTER //
// src/components/page/login/loginRegist.vue